export default {
    workspaceFeeders(state) {
        return state.workspaceFeeders;
    }
}